import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IProfileState } from './profile.reducer';

export const selectProfile = createFeatureSelector('profile');
export const selectCurrentProfile = createSelector(
  selectProfile,
  (profile: IProfileState) => {
    if (profile
      && profile.result
      && profile.entities
      && profile.entities.profiles
    ) {
      return profile.entities.profiles[profile.result];
    }
  }
);
